import script from "./AutoCompleteAlgolia.vue?vue&type=script&lang=js"
export * from "./AutoCompleteAlgolia.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__